import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';

const PublicOnly = ({children}) => {
    const {currentUser} = useAuth();

    if(currentUser) {
        return <Navigate to='/' replace />
    }
    return children;
};

export default PublicOnly;